/**
 *  @property { 重写loading组件 }
 *  @author guangzhen.ju.o
 *  @description  预留props参数， 暴露open close方法
 */
import Loading from './loading.vue'
import Vue from 'vue'

Loading.init = properties => {
  const props = properties || {}

  const Instance = new Vue({
    data: props,
    render (h) {
      return h(Loading, {
        props: props
      })
    }
  })

  const component = Instance.$mount()
  document.body.appendChild(component.$el)

  const loading = Instance.$children[0]

  return {
    open () {
      loading.showLoading = true
    },
    close () {
      loading.showLoading = false
    }
  }
}
export default Loading
